import { Input, Output, Component, EventEmitter } from '@angular/core';
import { DateRangeModel } from '../../../models/common/date.range';
import { Moment } from 'moment';

@Component({
    selector: 'date-range',
    template: require('./date.range.component.html'),
    styles: [require('./date.range.component.css')]
})
export class DateRangeComponent {
    @Input() model: DateRangeModel;
    @Input() disabled: boolean = false;
    @Input() modelName: string;

    @Output() modelChanged = new EventEmitter<any>();

    get toPlaceholder(): string {
        return this.modelName ? `${this.modelName} to` : 'To';
    }

    get fromPlaceholder(): string {
        return this.modelName ? `${this.modelName} from` : 'From';
    }

    onModelChanged() {
        this.modelChanged.emit();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/date.range/date.range.component.ts